import React, { useRef } from "react";


// MUI components - starts
import { Button, InputAdornment, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, IconButton, CircularProgress, FormControl, Autocomplete, Switch, Stack, TextField, FormGroup} from '@mui/material';
// MUI components - ends

//icons - starts
import UploadIcon from '@mui/icons-material/CloudUpload';
import LinkIcon from '@mui/icons-material/Link';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
//icons - ends

import PDFsContainerComponent from "../pdf-container-component/hoa-pool-access-form-pdf-container";

export default function HoaOnboardingModalEdit({ 
    activeState, 
    onboardingDocuments, 
    setOnboardingDocuments,
    onboardingDataState,
    setOnboardingDataState,
    shouldUpdateAvailable
}:any) {

    const handleOnboardingStateDataChange = (event:any, name:string, isCheckBox:boolean = false) => {
        const tempState:any = {
            ...onboardingDataState,
            [name]: {
                ...onboardingDataState[name],
                "data": {
                    ...onboardingDataState[name]["data"],
                    [event.target.name]: isCheckBox ? event.target.checked : event.target.value
                }
            }
        }

        setOnboardingDataState(tempState);
    }

    const handleFileUpload = (event:any, name:string) => {
        const tempState = {
            ...onboardingDocuments,
            [name]: [
                ...onboardingDocuments[name],
                ...Array.from(event.target.files)
            ]
        }

        setOnboardingDocuments(tempState);
    }

    const handleDeleteDocument = (name:any, file:any) => {
        const tempState = {
            ...onboardingDocuments,
            [name]: onboardingDocuments[name].filter((item:any) => (file.name && item.name && item.name != file.name) || (file.fileName && item.fileName && item.fileName != file.fileName))
        }

        setOnboardingDocuments(tempState);
    }

    return (
        <>
            {
                activeState == 1 ?
                <ClientDirectoryForm onboardingDocuments={onboardingDocuments} handleFileUpload={handleFileUpload} handleDeleteDocument={handleDeleteDocument} onboardingDataState={onboardingDataState} handleOnboardingStateDataChange={handleOnboardingStateDataChange} shouldUpdateAvailable={shouldUpdateAvailable}/>
                : activeState == 2 ?
                <PortalSearchForm onboardingDocuments={onboardingDocuments} handleFileUpload={handleFileUpload} handleDeleteDocument={handleDeleteDocument} onboardingDataState={onboardingDataState} handleOnboardingStateDataChange={handleOnboardingStateDataChange} shouldUpdateAvailable={shouldUpdateAvailable}/>
                : activeState == 3 ?
                <EmailHoaForm onboardingDocuments={onboardingDocuments} handleFileUpload={handleFileUpload} handleDeleteDocument={handleDeleteDocument} onboardingDataState={onboardingDataState} handleOnboardingStateDataChange={handleOnboardingStateDataChange}/>
                : activeState == 4 ?
                <CallHoaForm onboardingDocuments={onboardingDocuments} handleFileUpload={handleFileUpload} handleDeleteDocument={handleDeleteDocument} onboardingDataState={onboardingDataState} handleOnboardingStateDataChange={handleOnboardingStateDataChange}/>
                :
                <></>
            }
        </>
    )
}

const CallHoaForm = ({ onboardingDocuments, handleFileUpload, handleDeleteDocument, onboardingDataState, handleOnboardingStateDataChange }:any) => {
    const editEmailUploadButtonRef = useRef(null);
    const editEmailScreenShotButtonRef = useRef(null);

    const dataTypeName = "callHoa";

    return (
        <>
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px" }}>Screenshot</div>
            <Button style={{ marginBottom: "20px" }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{editEmailScreenShotButtonRef.current.click()}}>
                Upload Photos
                <input ref={editEmailScreenShotButtonRef} hidden type='file' multiple accept="image/*"
                    onChange={(event:any) => handleFileUpload(event, "callHoaScreenshot")}
                />
            </Button>
            {
                onboardingDocuments["callHoaScreenshot"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["callHoaScreenshot"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`callHoaScreenshot`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }
            <div className="text-14px-5B5B5B" style={{ marginTop: "30px", marginBottom: "20px" }}>Receiver's Contact Info</div>
            <TextField style={{ width: "87%", marginBottom: "20px" }} variant="standard" 
                name={"phone"}
                value={onboardingDataState[dataTypeName]["data"]["phone"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                label="Phone Number" InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{
                    style:{ padding:"7px 0px"},
                    endAdornment :(
                        <InputAdornment position="end">
                            <LocalPhoneIcon />
                        </InputAdornment>
            )}}/>
            <TextField style={{ width: "87%", marginBottom: "45px"}} variant="standard" 
                name={"email"}
                value={onboardingDataState[dataTypeName]["data"]["email"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                label="Email Address" InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{
                    style:{ padding:"7px 0px"},
                    endAdornment :(
                        <InputAdornment position="end">
                            <MailOutlineIcon />
                        </InputAdornment>
            )}}/>
            <div className="text-14px-5B5B5B" style={{ }}>Obtained Information</div>
            <FormControl style={{ fontSize:"14px"}}>
                <RadioGroup
                    row 
                    name={"obtainedInformation"}
                    value={onboardingDataState[dataTypeName]["data"]["obtainedInformation"]} 
                    onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                >
                    <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="Yes" control={<Radio color="primary"/>} label="Yes" />
                    <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="No" control={<Radio color="primary"/>} label="No" />
                </RadioGroup>
            </FormControl>
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px" }}>Documents</div>
            <Button style={{ marginBottom: "20px" }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{editEmailUploadButtonRef.current.click()}}>
                Upload Document
                <input ref={editEmailUploadButtonRef} hidden type='file' multiple accept="application/pdf,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(event:any) => handleFileUpload(event, "callHoa")}
                />
            </Button>
            {
                onboardingDocuments["callHoa"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["callHoa"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`callHoa`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px", marginTop: "45px" }}>Remarks</div>
            <TextField
                name={"remarks"}
                value={onboardingDataState[dataTypeName]["data"]["remarks"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%" }}
                label="Write here ..."
                multiline
                variant="outlined"
                InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{style:{ padding:"7px 7px", minHeight:"106px"}}}
            /> 
        </>
    )
}

const EmailHoaForm = ({ onboardingDocuments, handleFileUpload, handleDeleteDocument, onboardingDataState, handleOnboardingStateDataChange }:any) => {
    const editEmailUploadButtonRef = useRef(null);
    const editEmailScreenShotButtonRef = useRef(null);

    const dataTypeName = "emailHoa";

    return (
        <>
            <TextField 
                name={"emailSourceId"}
                value={onboardingDataState[dataTypeName]["data"]["emailSourceId"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%", marginBottom: "45px" }}
                label="Email Source ID" 
                variant="standard"
                InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                InputProps={{
                    style: { padding:"7px 0px" }
                }}
            />
            <div className="text-14px-5B5B5B" style={{ }}>Obtained Information</div>
            <FormControl style={{ fontSize:"14px"}}>
                <RadioGroup
                    row 
                    name={"obtainedInformation"}
                    value={onboardingDataState[dataTypeName]["data"]["obtainedInformation"]} 
                    onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                >
                    <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="Yes" control={<Radio color="primary"/>} label="Yes" />
                    <FormControlLabel style={{fontSize:"12px", lineHeight:"16px"}} value="No" control={<Radio color="primary"/>} label="No" />
                </RadioGroup>
            </FormControl>
            <div className="text-14px-5B5B5B" style={{ marginTop: "45px", marginBottom: "20px" }}>Documents</div>
            <Button style={{ marginBottom: "20px" }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{editEmailUploadButtonRef.current.click()}}>
                Upload Document
                <input ref={editEmailUploadButtonRef} hidden type='file' multiple accept="application/pdf,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(event:any) => handleFileUpload(event, "emailHoa")}
                />
            </Button>
            {
                onboardingDocuments["emailHoa"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["emailHoa"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`emailHoa`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }
            <div className="text-14px-5B5B5B" style={{ marginTop: "20px", marginBottom: "20px" }}>Screenshot</div>
            <Button style={{ marginBottom: "20px" }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{editEmailScreenShotButtonRef.current.click()}}>
                Upload Photos
                <input ref={editEmailScreenShotButtonRef} hidden type='file' multiple accept="image/*"
                    onChange={(event:any) => handleFileUpload(event, "emailHoaScreenshot")}
                />
            </Button>
            {
                onboardingDocuments["emailHoaScreenshot"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["emailHoaScreenshot"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`emailHoaScreenshot`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px", marginTop: "20px" }}>Remarks</div>
            <TextField
                name={"remarks"}
                value={onboardingDataState[dataTypeName]["data"]["remarks"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%" }}
                label="Write here ..."
                multiline
                variant="outlined"
                InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{style:{ padding:"7px 7px", minHeight:"106px"}}}
            />            
        </>
    )
}

const PortalSearchForm = ({onboardingDocuments, handleFileUpload, handleDeleteDocument, onboardingDataState, handleOnboardingStateDataChange, shouldUpdateAvailable}:any) => {
    const uploadButton1 = useRef(null);
    const dataTypeName = "portalSearch";

    return (
        <>
            <TextField 
                name={"portalLink"}
                value={onboardingDataState[dataTypeName]["data"]["portalLink"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%", marginBottom: "45px" }}
                variant="standard"
                label="Portal Link" 
                InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                InputProps={{
                    style: { padding:"7px 0px" },
                    endAdornment: (
                        <InputAdornment position="end">
                            <LinkIcon />
                        </InputAdornment>
            )}}/>
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px" }}>Documents</div>
            <Button style={{ marginBottom: "20px" }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{uploadButton1.current.click()}}>
                Upload Document
                <input ref={uploadButton1} hidden type='file' multiple accept="application/pdf,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(event:any) => handleFileUpload(event, "portalSearch")}
                />
            </Button>
            {
                onboardingDocuments["portalSearch"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["portalSearch"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`portalSearch`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }

            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px", marginTop: "20px" }}>Remarks</div>
            <TextField
                name={"remarks"}
                value={onboardingDataState[dataTypeName]["data"]["remarks"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%" }}
                label="Write here ..."
                multiline
                variant="outlined"
                InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{style:{ padding:"7px 7px", minHeight:"106px"}}}
            />

            <FormGroup style={{ marginTop: "30px" }}>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            name={"isDataUnavailable"}
                            checked={onboardingDataState[dataTypeName]["data"]["isDataUnavailable"]} 
                            onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName, true) }} 
                        />
                    } 
                    label="No details are available" 
                />
            </FormGroup>
        </>
    )
}

const ClientDirectoryForm = ({ onboardingDocuments, handleFileUpload, handleDeleteDocument, onboardingDataState, handleOnboardingStateDataChange, shouldUpdateAvailable }:any) => {
    const uploadButton1 = useRef(null);
    const dataTypeName = "clientDirectory";

    return (
        <>
            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px" }}>Documents</div>
            <Button style={{ }} startIcon={<UploadIcon color="primary"/>} variant="outlined" onClick={()=>{uploadButton1.current.click()}}>
                Upload Document
                <input ref={uploadButton1} hidden type='file' multiple accept="application/pdf,application/vnd.ms-excel, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(event:any) => handleFileUpload(event, "clientDirectory")}
                />
            </Button>
            {
                onboardingDocuments["clientDirectory"]?.length > 0 ?
                <div style={{ width: "75%" }}>
                    {
                        Array.from(onboardingDocuments["clientDirectory"]).map((file : any, index: number)=>{
                            return <PDFsContainerComponent document={`clientDirectory`} deleteClick={(document:any, file:any) => handleDeleteDocument(document, file)} view={"update"} key={index} file={file} />
                        })
                    }
                </div>
                : ''
            }
            <TextField 
                name={"hyperLink"}
                value={onboardingDataState[dataTypeName]["data"]["hyperLink"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%", marginBottom: "30px", marginTop: "20px" }}
                variant="standard"
                label="Hyperlink" 
                InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                InputProps={{
                    style: { padding:"7px 0px" },
                    endAdornment: (
                        <InputAdornment position="end">
                            <LinkIcon />
                        </InputAdornment>
            )}}/>

            <div className="text-14px-5B5B5B" style={{ marginBottom: "20px" }}>Remarks</div>
            <TextField 
                name={"remarks"}
                value={onboardingDataState[dataTypeName]["data"]["remarks"]} 
                onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName) }} 
                style={{ width: "87%" }}
                label="Write here ..."
                multiline
                variant="outlined"
                InputLabelProps={{style:{fontSize:"14px"}}}
                InputProps={{style:{ padding:"7px 7px", minHeight:"106px"}}}
            />

            <FormGroup style={{ marginTop: "30px" }}>
                <FormControlLabel 
                    control={
                        <Checkbox 
                            name={"isDataUnavailable"}
                            checked={onboardingDataState[dataTypeName]["data"]["isDataUnavailable"]} 
                            onChange={(e) => { handleOnboardingStateDataChange(e, dataTypeName, true) }} 
                        />
                    } 
                    label="No details are available" 
                />
            </FormGroup>
        </>
    )
}